var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showScrollToTop)?_c('div',{staticClass:"scroll-to-top text-center",class:{
    'scroll-to-top-higher': _vm.hasBeaconContainer,
    'scroll-to-top-higher-mobile': _vm.showHigher
  },on:{"click":_vm.scrollToTop}},[_vm._v("\n  Scroll to top\n  "),_c('div',{staticClass:"icon-container mt-1 text-center"},[_c('font-awesome-icon',{attrs:{"icon":"chevron-up"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }